import(/* webpackMode: "eager" */ "/var/www/clients/client1/web9/home/kupcochceszpanel/panel/src/app/global-error.tsx");
